import React from "react";
import "./HorizontalDivider.css";

function HorizontalDivider() {
    return (
        <hr className="horizontal-divider" />
    );
}

export default HorizontalDivider;
